import { ArrowLeft } from 'lucide-react';
import React from 'react';
import type {
  TenantSelectionConflicts,
  TenantSelectorRowData,
} from '../../../components/tenant-selector/types';
import { Button } from '../../../components/ui/button';
import type { TenantSelectionType } from '../engage-automations-tab/templates.types';
import styles from './EditSegment.module.css';
import { SegmentTenantSelectionControl } from './SegmentTenantSelectionControl';

interface EditSegmentHeaderProps {
  onBack: () => void;
  onSave: () => void;
  isSaveDisabled: boolean;
  isSaving: boolean;
  saveLabel?: string;
  tenantRowData: Record<string, TenantSelectorRowData>;
  conflicts: TenantSelectionConflicts | null;
  tenantSelectionType: TenantSelectionType;
  selectedTenantIds: string[];
  onTenantSelectionChange: (type: TenantSelectionType, ids: string[]) => void;
  isTenantSelectionDirty: boolean;
  isLoadingTenants?: boolean;
}

export const EditSegmentHeader: React.FC<EditSegmentHeaderProps> = ({
  onBack,
  onSave,
  isSaveDisabled,
  isSaving,
  saveLabel = 'Save Segment',
  tenantRowData,
  conflicts,
  tenantSelectionType,
  selectedTenantIds,
  onTenantSelectionChange,
  isTenantSelectionDirty,
  isLoadingTenants,
}) => {
  return (
    <header className={styles.header}>
      <button type="button" onClick={onBack}>
        <ArrowLeft />
        Back to Segments
      </button>
      <div className={styles.headerActions}>
        <SegmentTenantSelectionControl
          disabled={isSaving}
          tenantRowData={tenantRowData}
          conflicts={conflicts}
          tenantSelectionType={tenantSelectionType}
          selectedTenantIds={selectedTenantIds}
          onChange={onTenantSelectionChange}
          isDirty={isTenantSelectionDirty}
          isLoading={isLoadingTenants}
        />
        <Button onClick={onSave} disabled={isSaveDisabled}>
          {isSaving ? 'Saving...' : saveLabel}
        </Button>
      </div>
    </header>
  );
};
